import{ BROWSER_NOTIFICATION, BrowserNotificationAction, ComponentStyle, usePushNotifications } from '@/imports-files/components/browser-notification'
import { BlueLogo } from '@/imports-files/pages/career/view-job';

export function BrowserNotification(props)
{
    const actions                                                                                 =     new BrowserNotificationAction();
    const { userConsent, setUserConsent, onClickAskUserPermission, onClickCancelUserPermission}   =     usePushNotifications();

  
    return(
            <div className  =   {ComponentStyle.BrowserNotification}>
                <div className = {ComponentStyle.BrowserNotification__content}>
                    <div className = {ComponentStyle.BrowserNotification__LogoImage}>
                   <img alt="logo-image" src='/images/logo/Bluelogo.png'/>
                    </div>
                    <div className = {ComponentStyle.BrowserNotification__Message}>
                        <p><b>Charlie Recruit wants to start sending you push notifications.</b></p>
                        <p>Click Allow to Subscribe</p>
                    </div>
                </div>
                <div className={ComponentStyle.BtnSection}>
                    <button className   =  {ComponentStyle.ClearBtn} onClick = {()=>{ setUserConsent('denied'); actions.cancel(props.setNotificationModal, onClickCancelUserPermission)}}>{BROWSER_NOTIFICATION.texts.button_2}</button>
                    <button className   =  {ComponentStyle.AllowBtn} onClick = {()=>{ props.setNotificationModal(false); onClickAskUserPermission() }}>{BROWSER_NOTIFICATION.texts.button_1}</button>
                </div>
            </div>
          )
}